import { gsap } from 'gsap';

interface ITargetHTML extends HTMLElement {
    timeline?: {};
}

const options = {
    threshold: 0.6,
    rootMargin: '0px 0px 0px 0px',
};

const callback = function (entries, observer) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            entry.target.timeline.play();
        }
    });
};

const observer: IntersectionObserver = new IntersectionObserver(callback, options);
const targets = document.querySelectorAll<HTMLElement>('.stock__number');

// create the individual target timelines
targets.forEach((target: ITargetHTML) => {
    // use document lang to show dot or ,
    const lang = document.documentElement.lang || 'no';
    const fromValue = { value: 0 };
    const toValue = target.dataset.value.replace(',', '.') || 0;
    const showPercentage = target.dataset.showpercentage || false;
    const visibleCounter = target.getElementsByClassName('stock__number__counter')[0];
    const action = gsap.timeline({ paused: true }).to(fromValue, {
        value: toValue,
        duration: 3,
        ease: 'Power4.easeInOut',
        onUpdate: function () {
            lang === 'no' || lang === 'sv'
                ? (visibleCounter.innerHTML = `${fromValue.value.toFixed(1).replace('.', ',')}${showPercentage ? '%' : ''}`)
                : (visibleCounter.innerHTML = `${fromValue.value.toFixed(1)}${showPercentage ? '%' : ''}`);
        },
    });

    target.timeline = action;
});

Array.prototype.forEach.call(targets, (el) => {
    observer.observe(el);
});
